exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TopNav-module__name___25C4z{font-size:14px;font-weight:700}.TopNav-module__name___25C4z,.TopNav-module__role___26yTc{line-height:1.2}.TopNav-module__role___26yTc{font-size:12px;font-weight:400}", ""]);

// exports
exports.locals = {
	"name": "TopNav-module__name___25C4z",
	"role": "TopNav-module__role___26yTc"
};